const LoadingSpinner = () => {
  return (
    <div className='flex flex-col items-center justify-center p-8'>
      <div className='w-12 h-12 border-4 border-neutral-200 border-t-primary-500 rounded-full animate-spin'></div>
      <p className='mt-4 text-neutral-600'>Loading...</p>
    </div>
  );
};

export default LoadingSpinner;
